<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      border
      row-id="locationCode"
      :checkbox-config="{ highlight: true, reserve: true }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      @cell-click="cellClick"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('btn_relocation') || '移库'"
          placement="top"
        >
          <i
            class="el-icon-position tool-btn"
            @click="$emit('openRelocationDialog', row)"
          ></i>
        </el-tooltip>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:isLast="{ row }">
        <el-tag size="mini" :type="row.isLast == 'Y' ? 'primary' : 'danger'">
          {{ row.v_isLast }}
        </el-tag>
      </template>
      <template v-slot:locationStatus="{ row }">
        <el-tag
          size="mini"
          :type="
            row.locationStatus == 'Y'
              ? 'success'
              : row.locationStatus == 'D'
              ? 'danger'
              : ''
          "
        >
          {{ row.v_locationStatus }}
        </el-tag>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    // printTag() {
    //   // 缓存的选中数据，非当前页数据
    //   let reserveRecords = this.$refs.table.getCheckboxReserveRecords()
    //   // 当前页选中的数据
    //   let selectRecords = this.$refs.table.getCheckboxRecords()
    //   let totCount = reserveRecords.length + selectRecords.length
    //   if (totCount === 0) {
    //     this.$message.warning('请选择需要打印标签的库位信息')
    //     return false
    //   }
    //   if (totCount > 20) {
    //     this.$message.warning('一次打印的数量不能超过20个')
    //     return false
    //   }
    //   this.selectList = []
    //   // 将缓存中的选中数据，加入已选中数据列表
    //   if (reserveRecords.length > 0) {
    //     reserveRecords.forEach((row) => {
    //       this.selectList.push(row.locationCode)
    //     })
    //   }
    //   // 将当前页选中数据，加入已选中数据列表
    //   if (selectRecords.length > 0) {
    //     selectRecords.forEach((row) => {
    //       this.selectList.push(row.locationCode)
    //     })
    //   }
    //   this.print()
    // },
    // printPdf(locationCode) {
    //   this.selectList = [locationCode]
    //   this.print()
    // },
    // print() {
    //   if (this.selectList.length < 1) {
    //     this.$message({
    //       showClose: true,
    //       message: '请选择需要打印的标签',
    //       type: 'warning',
    //     })
    //     return
    //   }
    //   let data = { locationCodeList: this.selectList }
    //   let fileName = '库位标签'
    //   this.$api.globalExportData(
    //     '/samplemanage/masterStorageLocation/print',
    //     data,
    //     fileName
    //   )
    //   this.$refs.table.clearCheckboxRow()
    //   this.$refs.table.clearCheckboxReserve()
    // },
    checkboxChange({ records, reserves }) {
      this.$emit('checkboxChange', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkboxChange', [])
    },
    cellClick({ row, column }) {
      const { property } = column
      const filterColumns = ['checkbox', 'col-opt']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)

      const data = $table
        .getCheckboxRecords(true)
        .concat($table.getCheckboxReserveRecords(true))
      this.$emit('checkboxChange', data)
    },
  },
}
</script>
